/* Article promo (Stage 2): reveal preview items for QA, and run the sticky bar. */
(function () {
  var preview = /[?&]cards=preview(&|$)/.test(window.location.search);

  document.querySelectorAll('[data-promo-preview]').forEach(function (el) {
    if (preview) el.removeAttribute('hidden');
  });

  var bar = document.querySelector('[data-promo-bar]');
  if (!bar || bar.hasAttribute('hidden')) return;

  var storageKey = 'articlePromoBarDismissed';
  try {
    if (window.sessionStorage.getItem(storageKey) === '1') {
      bar.parentNode.removeChild(bar);
      return;
    }
  } catch (e) {}

  var closeButton = bar.querySelector('[data-promo-close]');
  var dismissed = false;
  var ticking = false;

  function setVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('article-promo-bar-on', visible);
    if (visible) {
      bar.removeAttribute('aria-hidden');
    } else {
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  function update() {
    ticking = false;
    if (dismissed) return;
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    var progress = max > 0 ? window.scrollY / max : 0;
    setVisible(progress >= 0.3);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      dismissed = true;
      setVisible(false);
      try {
        window.sessionStorage.setItem(storageKey, '1');
      } catch (e) {}
      window.removeEventListener('scroll', onScroll);
    });
  }

  bar.setAttribute('aria-hidden', 'true');
  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
